export default __webpack_public_path__ + "static/media/header-registration.068527fe.png";